<template>
  <div class="container" :style="{'padding':formPadding}" v-loading="formLoading">
     <el-form ref="formRef" :model="props.formData" class="form" :label-position="props.labelPosition" :size="formSize"
        :rules="props.formRules" :label-width="props.labelWidth" :hide-required-asterisk="props.hideRequiredIcon">
        <el-row :gutter="props.gutter" class="row">
          <template v-for="item in props.formOptions" :key="item.type">
            <el-col :span="item.span" v-if="!item.hide">
              <el-form-item :label="item.label" :prop="item.prop" :label-width="item.labelWidth" style="width:100%">
                <slot :name="item.prop" v-if="item.template" :row="item"></slot>
                <el-input v-else-if="item.type === 'input'" v-model.trim="props.formData[item.prop]"
                  :placeholder="item.placeholder" :clearable="item.clearable" :type="item.inputType"
                  :maxlength="item.maxlength" :show-password="item.showPassword && true" :disabled="item.disabled">
                </el-input>
                <el-button v-else-if="item.type === 'button'" :style="{'width':item.buttonWidth}" :type="item.buttonType" :plain="item.plain" :size="item.size"
                  @click="buttonClick(item)">{{ item.prop }}</el-button>
                <el-select v-else-if="item.type === 'select'" v-model="props.formData[item.prop]" :multiple="item.multiple" 
                    :placeholder="item.placeholder" :clearable="item.clearable" :filterable="item.filterable" :remote="item.remote" @change="(item.changeFunction)" 
                    :reserve-keyword="item.reserveKeyword" :remote-show-suffix="item.remoteShowSuffix" :loading="selectLoading" :allow-create="item.allowCreate"
                    :remote-method="(query) => selectSearch(query,item)" loading-text="正在搜索" default-first-option 
                    >
                    <el-option v-for="item1 in item.options" :key="item1.value" :label="item1.label" :value="item1.value">
                      <span style="margin-left: 0.1rem; line-height: 0.18rem">{{item1.label}}</span>
                    </el-option>
                </el-select>
                <el-radio-group v-else-if="item.type === 'radio'" v-model="props.formData[item.prop]">
                  <el-radio v-for="item1 in item.options" :value="item1.value" :size="item1.size">{{ item1.label }}</el-radio>
                </el-radio-group>
                <el-autocomplete style="width: 100%;" v-else-if="item.type === 'searchInput'" v-model="formData[item.prop]" :trigger-on-focus="false" :fetch-suggestions="(queryString:string, cb:any) => { return querySearch(queryString,cb,item)}" @select="handleSearchInputSelect" :placeholder="item.placeholder" :value-key="item.keyValue"></el-autocomplete>
              </el-form-item>
              
            </el-col>
          </template>
          <el-col :span="props.buttonSpan" v-if="props.showFooterButton">
            <el-form-item label-width="0">
              <div style="display: flex;justify-content: space-around;margin-top: 20px;width: 100%;">
                <slot name="leftButton"></slot>
                <el-button v-if="props.showResetButton" @click="resetForm(formRef)" style="width: 120px;">重置</el-button>
                <el-button class="searchButton" type="primary" @click="submitForm()" style="width: 120px;" :style="submitButtonStyle">{{ submitButtonName }}</el-button>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
     </el-form>
  </div>
</template>

<script setup>
import { ref,reactive,defineExpose,defineProps } from "vue"
import { ElMessage, ElMessageBox } from "element-plus";

const props = defineProps({
  formOptions:{
    type: Object,
    default: () => ({})
  },
  formData:{
    type: Object,
    default: () => ({})
  },
  formRules:{
    type: Object,
    default: () => ({})
  },
  apiMethod: {
    type: Function,
    default: undefined
  },
  labelPosition:{
    type:String,
    default:"left"
  },
  labelWidth:{
    type:String,
    default:"100px"
  },
  hideRequiredIcon:{
    type:Boolean,
    default:false
  },
  formPadding:{
    type:String,
    default:"40px"
  },
  gutter:{
    type:Number,
    default:30
  },
  buttonSpan:{
    type:Number,
    default:24
  },
  showFooterButton:{
    type:Boolean,
    default:true
  },
  submitButtonName:{
    type:String,
    default:"提交"
  },
  formSize:{//<'' | 'large' | 'default' | 'small'>
    type:String,
    default:"default"
  },
  showResetButton:{
    type:Boolean,
    default:true
  },
  submitButtonStyle:{
    type: Object,
    default: () => ({})
  }
})

const formLoading = ref(false)

const emit = defineEmits(['update:formLoading','buttonClick','submitForm','submitFormRes'])

const buttonClick = (item) =>{
  emit('buttonClick',item)
  // item.value === "export" && this.$message('导出功能');
  // item.value === "search" && this.getList()
  item.value === "reset" && formRef.value.resetFields()
}

const selectLoading = ref(false)
const selectSearch = (query,item) =>{
  let { api , searchKeyWord , optionsValue ,optionsLabel }  = item
  selectLoading.value = true
  let Value = optionsValue ? optionsValue : 'value'
  let Label = optionsValue ? optionsLabel : 'label'
  setTimeout(() => {
    api({ [searchKeyWord] : query }).then((res) =>{
      item.options = res.data.map((item) => { return { value:item[Value],label:item[Label] }  } );
      selectLoading.value = false
    })
  },200)
}

const querySearch = (queryString, cb , item) =>{
  let { api , searchKeyWord , params }  = item
  let cs = params ? params() ? params() : {} : {}
  api({ [searchKeyWord]: queryString , ...cs }).then((res) =>{
    if(res.status === 10000){
      cb(res.data)
    }else{
      cb([])
    }
  })
}
const handleSearchInputSelect = () =>{}

const formRef = ref()
const submitForm = async () => {
  await formRef.value.validate((valid, fields) => {
    if (valid) {
      if(props.apiMethod){
        formLoading.value = true;
        props.apiMethod(props.formData).then((res) =>{
          formLoading.value = false;
          emit("submitFormRes",res)
        })
      }else{
        emit("submitForm")
      }
    } else {
      formLoading.value = true;
      setTimeout(()=>{
        ElMessage.error("校验未通过")
        formLoading.value = false;
      },500)
      console.log('error submit!', fields)
    }
  })
}

const resetForm = (formEl) => {
  if (!formEl) return
  formEl.resetFields()
}

const validateField = (prop) =>{
  return new Promise((resolve,reject) =>{
    formRef.value.validateField([prop],(val) =>{
      resolve(val)
    })
  })
}

defineExpose({
  validateField,
  formLoading,
  submitForm
})
</script>

<style lang="scss" scoped>
</style>